var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ValuesType } from '@/support/HelperTypes';
import AQuillEditor from '@/components/AQuillEditor/AQuillEditor.vue';
import i18n from '@/i18n';
let PlanTemplateRow = class PlanTemplateRow extends Vue {
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    removeLearningObjective() {
        this.$emit('remove', this.objective);
    }
    // #endregion
    // #region Async methods
    // #endregion
    // #region Getters & Setters
    // #endregion
    // #region @Watchers
    onObjectiveChange(newValue, oldValue) {
        // console.log('newValue: ', newValue);
        // console.log('oldValue: ', oldValue);
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Array)
], PlanTemplateRow.prototype, "studentList", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", Object)
], PlanTemplateRow.prototype, "objective", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], PlanTemplateRow.prototype, "showDeleteIcon", void 0);
__decorate([
    Prop({
        default: () => ({
            placeholder: i18n.tc('student_plan.template.quill'),
        }),
    }),
    __metadata("design:type", typeof (_b = typeof Partial !== "undefined" && Partial) === "function" ? _b : Object)
], PlanTemplateRow.prototype, "editorOptions", void 0);
__decorate([
    Watch('objective', { immediate: true, deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_c = typeof ValuesType !== "undefined" && ValuesType) === "function" ? _c : Object, typeof (_d = typeof ValuesType !== "undefined" && ValuesType) === "function" ? _d : Object]),
    __metadata("design:returntype", void 0)
], PlanTemplateRow.prototype, "onObjectiveChange", null);
PlanTemplateRow = __decorate([
    Component({
        components: {
            AQuillEditor,
        },
    })
], PlanTemplateRow);
export default PlanTemplateRow;
